import { memo, forwardRef } from "react"
import { FixedSizeList } from 'react-window'
import AutoSizer from 'react-virtualized-auto-sizer'

/**
 * O children renderizado aqui, recebe um objeto com duas propriedas: { index, style }. Sendo index, o elemento da lista a ser renderizado,
 * e style, as propriedades css para o esquema de páginação funcionar. O style obrigatoriamente deve ser aplicado a div principal do elemento
 * filho. Ex: <div style={style}></div>
*/
const PaginacaoVertical = forwardRef((props, ref) => {
    const { itemCount, itemSize = 60, children } = props
    if (!itemCount) {
        return false
    }

    return (
        <AutoSizer>
            {({ height, width }) => {
                return (
                    <FixedSizeList
                        height={height}
                        itemCount={itemCount}
                        itemSize={itemSize}
                        width={width}
                        ref={ref}
                    >
                        {children}
                    </FixedSizeList>)
            }}
        </AutoSizer>
    )
})

export default memo(PaginacaoVertical)

/**
 * Para implementar a busca dos dados tambem páginada, ler a sessão "Implementando a páginação"
 * desse artigo: https://wanago.io/2022/06/27/long-lists-react-virtualization/,
 * que usa o módulo react-window-infinite-loader
*/
